import React from 'react';
import { usePatient } from '../../../../contexts/patient';
import PatientInformationSectionComponent from '../../../../components/Cards/Report/Questionnaire/Sections/Patient';

const PatientInformationSection = () => {
  const patientContext = usePatient();
  return (
    <PatientInformationSectionComponent
      birthDate={patientContext.getDateOfBirth()}
      displayName={patientContext.getDisplayName()}
      mrn={patientContext.getMrn()}
    />
  );
};

export default PatientInformationSection;
